import { getLowestPrice } from '~/modules/price/parsers';

// Todos: maybe move this to common utils later or move 'formatPrice' to here
export const getFormattedPrice = (selectedPrice) => {
  const price = getLowestPrice(selectedPrice);
  return Number(price)?.toFixed(2);
};
